import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 100 120"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m35.8 115.625 52.391-52.39-24.05-24.051-8.88-8.883L2.868 82.695a1.45 1.45 0 0 0 0 2.043l7.235 7.235a1.42 1.42 0 0 0 1.511.332c4.055-1.575 8.828-.735 12.102 2.539 3.27 3.273 4.11 8.047 2.535 12.101a1.42 1.42 0 0 0 .336 1.512l7.172 7.168a1.44 1.44 0 0 0 2.043 0",
      style: {"stroke":"none","fill-rule":"nonzero","fill":"#2972b9","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      d: "m32.668 85.79 39.11-39.106 16.46 16.464z",
      style: {"stroke":"none","fill-rule":"nonzero","fill":"#151b21","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M52.395.422 0 52.816l32.93 32.93 52.394-52.394a1.443 1.443 0 0 0 0-2.04l-7.234-7.234a1.42 1.42 0 0 0-1.512-.336c-4.05 1.574-8.828.735-12.098-2.535-3.273-3.273-4.113-8.047-2.539-12.102a1.42 1.42 0 0 0-.336-1.511L54.434.422a1.443 1.443 0 0 0-2.04 0",
      style: {"stroke":"none","fill-rule":"nonzero","fill":"#53ade0","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }